import { render } from "./languages.vue?vue&type=template&id=28d96e42&scoped=true&ts=true"
import script from "./languages.vue?vue&type=script&lang=ts"
export * from "./languages.vue?vue&type=script&lang=ts"

import "./languages.vue?vue&type=style&index=0&id=28d96e42&lang=scss&scoped=true"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d96e42"]])

export default __exports__